export const DOCS_RELEASE_NOTES_TAB_KEY = "release-notes";

export const RELEASES = [
  { title: "Release 26.3.3 - September, 2026", version: "26.3.3" },
  { title: "Release 26.3.2 - August, 2026", version: "26.3.2" },
  { title: "Release 26.3.1 - July, 2026", version: "26.3.1" },
  { title: "Release 26.2.3 - June, 2026", version: "26.2.3" },
  { title: "Release 26.2.2 - May, 2026", version: "26.2.2" },
  { title: "Release 26.2.1 - April, 2026", version: "26.2.1" },
  { title: "Release 26.1.3 - March, 2026", version: "26.1.3" },
  { title: "Release 26.1.2 - February, 2026", version: "26.1.2" },
  { title: "Release 26.1.1 - January, 2026", version: "26.1.1" },
  { title: "Release 25.4.3 - December, 2025", version: "25.4.3" },
  { title: "Release 25.4.2 - November, 2025", version: "25.4.2" },
  { title: "Release 25.4.1 - October, 2025", version: "25.4.1" },
  { title: "Release 25.3.3 - September, 2025", version: "25.3.3" },
  { title: "Release 25.3.2 - August, 2025", version: "25.3.2" },
  { title: "Release 25.2.1 - July, 2025", version: "25.2.1" },
  { title: "Release 25.1.6 - June, 2025", version: "25.1.6" },
  { title: "Release 25.1.5 - May, 2025", version: "25.1.5" },
  { title: "Release 25.1.4 - April, 2025", version: "25.1.4" },
  { title: "Release 25.1.3 - March, 2025", version: "25.1.3" },
  { title: "Release 25.1.2 - February, 2025", version: "25.1.2" },
  { title: "Release 25.1.1 - January, 2025", version: "25.1.1" },
  { title: "Release 24.4.3 - December, 2024", version: "24.4.3" },
  { title: "Release 24.4.2 - November, 2024", version: "24.4.2" },
  { title: "Release 24.4.1 - October, 2024", version: "24.4.1" },
  { title: "Release 24.3.3 - September, 2024", version: "24.3.3" },
  { title: "Release 24.3.2 - August, 2024", version: "24.3.2" },
  { title: "Release 24.3.1 - July, 2024", version: "24.3.1" },
  { title: "Release 24.2.3 - June, 2024", version: "24.2.3" },
  { title: "Release 24.2.2 - May, 2024", version: "24.2.2" },
  { title: "Release 24.2.1 - April, 2024", version: "24.2.1" },
  { title: "Release 24.1.3 - March, 2024", version: "24.1.3" },
  { title: "Release 24.1.2 - February, 2024", version: "24.1.2" },
  { title: "Release 24.1.1 - January, 2024", version: "24.1.1" },
  { title: "Release 23.4.3 - December, 2023", version: "23.4.3" },
  { title: "Release 23.4.2 - November, 2023", version: "23.4.2" },
  { title: "Release 23.4.1 - October, 2023", version: "23.4.1" },
  { title: "Release 23.3.4 - September, 2023", version: "23.3.4" },
  { title: "Release 23.3.3 - August, 2023", version: "23.3.3" },
  { title: "Release 23.3.2 - July, 2023", version: "23.3.2" },
  { title: "Release 23.3.1 - July, 2023", version: "23.3.1" },
  { title: "Release 23.2.6 - June, 2023", version: "23.2.6" },
  { title: "Release 23.2.5 - May, 2023", version: "23.2.5" },
  { title: "Release 23.2.4 - May, 2023", version: "23.2.4" },
  { title: "Release 23.2.3 - April, 2023", version: "23.2.3" },
  { title: "Release 23.2.2 - April, 2023", version: "23.2.2" },
  { title: "Release 23.2.1 - April, 2023", version: "23.2.1" },
  { title: "Release 23.1.3 - March, 2023", version: "23.1.3" },
  { title: "Release 23.1.2 - February, 2023", version: "23.1.2" },
  { title: "Release 23.1.1 - January, 2023", version: "23.1.1" },
  { title: "Release 22.4.3 - December, 2022", version: "22.4.3" },
  { title: "Release 22.4.2 - November, 2022", version: "22.4.2" },
  { title: "Release 22.4.1 - October, 2022", version: "22.4.1" },
  { title: "Release 22.3.5 - September, 2022", version: "22.3.5" },
  { title: "Release 22.3.4 - August, 2022", version: "22.3.4" },
  { title: "Release 22.3.3 - August, 2022", version: "22.3.3" },
  { title: "Release 22.3.2 - August, 2022", version: "22.3.2" },
  { title: "Release 22.3.1 - July, 2022", version: "22.3.1" },
  { title: "Release 22.2.4 - June, 2022", version: "22.2.4" },
  { title: "Release 22.2.3 - May, 2022", version: "22.2.3" },
  { title: "Release 22.2.2 - May, 2022", version: "22.2.2" },
  { title: "Release 22.2.1 - April, 2022", version: "22.2.1" },
  { title: "Release 22.1.2 - April, 2022", version: "22.1.2" },
];

export const LAST_VIEWED_LS_KEY = "last_viewed_release_notes";
